import { CSSProperties, useMemo } from 'react';
import classNames from "classnames";
import styles from "./dcui-theming-logo-container.less";

type DCUIThemingLogoContainerProps = {
    className?: string;
    logoUrl: string;
    alignLogo?: string;
    idpName?: string;
    rpName?: string;
    altText: string;
    width?: number;
    height?: number;
    section: string;
};

export const DCUIThemingLogoContainer = (props: DCUIThemingLogoContainerProps) => {
    const { className, logoUrl, idpName, rpName, altText, section, alignLogo, width, height } = props;

    const finalAltText = useMemo(() => {
        if (altText) {
            return altText;
        } else if (rpName) {
            return `${rpName} Logo`;
        } else if (idpName) {
            return `${idpName} Logo`;
        }
        return "Logo";
    }, [altText, rpName, idpName]);

    const logoClassName = useMemo(() => {
        return section === "header" ? styles.logoWithMaxWidth : "";
    }, [section]);

    const logoContainerStyle: CSSProperties = {
        justifyContent: alignLogo
    };

    const imageStyle: CSSProperties = {
        width: !isNaN(width) ? width : undefined,
        height: !isNaN(height) ? height : undefined,
        maxWidth: "100%"
    };

    return (
        <div className={classNames(styles.dcuiThemingLogoContainer, "logo-container", className || "")} style={logoContainerStyle}>
            <img className={logoClassName} src={logoUrl} alt={finalAltText} style={imageStyle} />
        </div>
    );
};